import { ListenableDispatcher } from "./listenable";
export var ParticleEventType;
(function (ParticleEventType) {
    ParticleEventType["POSITION_UPDATE"] = "positionUpdate";
    ParticleEventType["COLOR_UPDATE"] = "colorUpdate";
    ParticleEventType["UPDATE"] = "update";
})(ParticleEventType || (ParticleEventType = {}));
export class BaseListenableParticle extends ListenableDispatcher {
}
